// Google Analytics 4 Implementation
declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js',
      targetId: string | Date,
      config?: Record<string, any>
    ) => void;
    dataLayer: any[];
  }
}

const GA_MEASUREMENT_ID = 'G-V3HZM85DEQ';

// Initialize analytics and check for admin mode
export const initializeAnalytics = () => {
  // Check if user is in admin mode (to prevent self-tracking)
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('admin') === 'true') {
    localStorage.setItem('ga_admin_mode', 'true');
    console.log('[Analytics] Admin mode enabled - tracking disabled');
  }
  
  const isAdmin = localStorage.getItem('ga_admin_mode') === 'true';
  if (isAdmin) {
    console.log('[Analytics] Admin mode active - tracking disabled');
  }
};

// Check if gtag is available and user is not admin
const canTrack = (): boolean => {
  const isAdmin = localStorage.getItem('ga_admin_mode') === 'true';
  return typeof window.gtag !== 'undefined' && !isAdmin;
};

// Track page views
export const trackPageView = (url: string) => {
  if (!canTrack()) return;
  
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: url,
  });
  
  console.log('[Analytics] Page view tracked:', url);
};

// Track custom events
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (!canTrack()) return;
  
  window.gtag('event', eventName, parameters);
  console.log('[Analytics] Event tracked:', eventName, parameters);
};

// Helper functions for common events
export const trackFormSubmission = (formName: string) => {
  trackEvent('form_submission', { form_name: formName });
};

export const trackButtonClick = (buttonName: string, location: string) => {
  trackEvent('button_click', { button_name: buttonName, location });
};

export const trackPhoneCall = (source: string) => {
  trackEvent('phone_call', { source });
};

export const trackServiceView = (serviceName: string) => {
  trackEvent('service_view', { service_name: serviceName });
};

export const trackEstimateRequest = (serviceType?: string) => {
  trackEvent('estimate_request', { service_type: serviceType || 'general' });
};
